import { MenuType, PageTypeSuffix } from '@/constants'
import { useStore } from '@/containers'
import { type Menu } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import PlaceDropdownIcon from '../Icon/PlaceDropdownIcon'
import PlaceIcon from '../Icon/PlaceIcon'

interface QuickMenuProps {
  quickMenuData: Menu[]
  className?: string
}

export const QuickMenu = ({ quickMenuData, className }: QuickMenuProps) => {
  const { asPath } = useRouter()
  const { regions, saleRegion, setIsOpenPopupLocation } = useStore()
  const store = regions.find(e => e.code === saleRegion)

  const checkActive = (item: string) => {
    if (asPath == item) {
      return 'text-blue'
    }
  }

  return (
    <div
      className={`relative z-10 flex h-12 w-full items-center gap-16 ${className}`}
    >
      <button
        onClick={() => setIsOpenPopupLocation(true)}
        className='flex h-9 items-center gap-2 whitespace-nowrap rounded-full border-none fill-main stroke-main text-sm font-semibold text-main outline-none'
      >
        <PlaceIcon />
        <span>{store?.name || 'Chọn địa điểm'}</span>
        <PlaceDropdownIcon />
      </button>

      <div
        className={`flex grow items-center gap-12 overflow-auto whitespace-nowrap text-main scrollbar-hide`}
      >
        {quickMenuData &&
          quickMenuData.map((item, index) => {
            return (
              <Link
                href={
                  item.type === MenuType.PRODUCT_CAT
                    ? `/${item.slug + PageTypeSuffix.CATEGORY}`
                    : item.url || '/'
                }
                key={index}
                className={`flex items-center gap-2.5 text-sm font-semibold hover:text-blue-400 ${checkActive(
                  '/' + item.slug + PageTypeSuffix.CATEGORY
                )}`}
              >
                {item.icon && (
                  <Image
                    width={24}
                    height={24}
                    alt={getTranslate(item.name) || ''}
                    src={item.icon}
                    className='h-6 w-6'
                    priority
                  />
                )}
                <span>{getTranslate(item.name)}</span>
              </Link>
            )
          })}
      </div>
    </div>
  )
}
